import Vue from 'vue'

import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'
import './mixins'
import './thirdParty'
import './vue-component'
import './vue-filter'
import './assets/css/vendors.min.css'
import './assets/css/style.css'
import './assets/css/style-base.css'
import './assets/css/style_other.css'
import './assets/css/select2.css'
import './assets/css/responsive.css'
import '@/assets/global.css'
import 'viewerjs/dist/viewer.css'
import './assets/css/toast.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
VueViewer.setDefaults({
  zoomRatio: 0.2,
  minZoomRatio: 0.3
})

router.afterEach(() => {
  app.loading = false
})

const app = new Vue({
  name: 'Root',
  data: { loading: true, loadingMx: false },
  router,
  store,
  async created () {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
    window.addEventListener('storage', function (e) {
      if (e.isTrusted && (e.key === 'token' || e.key === 'userData')) {
        location.reload()
      }
    })
  },

  beforeDestroy () {
    window.removeEventListener('resize', () => store.commit('dom/SE_TWINDOW_WIDTH', window.innerWidth))
  },
  render: h => h(AppLayout)
}).$mount('#app')
